

function CustomButton(props) {

    const {
        isLoading = false,
        handleClick,
        title,
        type = 'button',
        isDisabled = null,
        icon = null,
        iconToLeft = null,
        isStart = false,
        buttonType = "primary",
        fontSize = '12px',
        paddingZero = false

    } = props

    return (
        <>
            <button style={{
                fontSize: `${fontSize}`,
                height: "36px",
                textWrap: "nowrap",
                position: "relative",
                minWidth: "fit-content",
                padding: paddingZero ? "0" : "0 20px",
                marginRight: '0px'
            }}
                type={type}
                className={`btnVldt ${buttonType === 'primary' ? "" : buttonType === 'secondary' ? "buttonSecoundry" : 'buutonTertiory'}`}
                disabled={isDisabled ? isDisabled : isLoading}
                onClick={handleClick}
            >
                <span style={{ visibility: "hidden", display: "inline-block" }}>
                    {title} {icon && <img src={icon} height={20} width={20} />}
                </span>
                <span style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)" }}>
                    {isLoading ? (
                        <div
                            className={`spinner-border ${buttonType === 'primary' ? "text-light" : "text-primary"}`}
                            role="status"
                            style={{ width: "20px", height: "20px" }}
                        />
                    ) : (<>
                        {iconToLeft && <img style={{ marginRight: '3px', stroke: 'red' }} src={iconToLeft} height={16} width={16} />}      {title} {icon && <img src={icon} height={20} width={20} style={{ marginLeft: '5px' }} />}
                    </>
                    )}

                </span>
            </button >
        </>
    )

}

export default CustomButton